import { useQuery } from '@tanstack/react-query';
import { getExperimentGroup } from '~/apis/abtest';
import { useAppContext } from '~/contexts/AppContext/AppContext';

/**
 * AB 테스트 진행시, UID 기반으로 각 사용자를 테스트 그룹에 할당한다.
 *
 * {@link} https://quicket.atlassian.net/wiki/spaces/DEV/pages/3538518732/A+B
 */
export const useGetExperimentGroup = (key: string) => {
  const appLogContext = useAppContext().appLogContext;

  return useQuery({
    queryKey: ['experiment', key],
    queryFn: () =>
      getExperimentGroup({
        experimentKey: key,
        userId: Number(appLogContext?.user_id),
        buid: appLogContext?.buid,
        deviceType: appLogContext?.device_type,
        appVersion: appLogContext?.app_version,
      }),
    select: (response) => response.data.experimentGroup,
    enabled: !!appLogContext?.user_id,
    retry: 0,
  });
};
